export default __webpack_public_path__ + "static/FieldworkStudio-7cdc26bcf9f103ff8aac66e7e8a1a834.png";